<!-- src/components/NoticeCenter.vue -->
<template>
  <el-dialog
      title="通知中心"
      :visible.sync="dialogVisible"
      width="1100px"
      :close-on-click-modal="false"
      top="5vh"
      @closed="handleClosed"
  >
    <!-- 整个内容区域滚动 -->
    <div style="max-height: 65vh; overflow-y: auto; padding-right: 4px;">
      <!-- Tab 切换 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="价格变动通知" name="price">
          <div v-loading="priceLoading" style="min-height: 300px;">
            <!-- 空状态 -->
            <div v-if="priceList.length === 0 && !priceLoading" style="text-align: center; padding: 60px 0; color: #909399;">
              <i class="el-icon-document" style="font-size: 48px; color: #d1d5db;"></i>
              <p style="margin-top: 12px; font-size: 14px;">暂无价格变动通知</p>
            </div>
            <!-- 价格列表 - 表格 -->
            <div v-else>
              <div style="margin-bottom: 12px; padding: 12px 16px; background: #fdf6ec; border-radius: 4px; border-left: 4px solid #e6a23c;">
                <i class="el-icon-warning" style="color: #e6a23c; font-size: 16px; margin-right: 8px;"></i>
                <span style="color: #e6a23c; font-weight: bold;">当前价格变动提醒如下，请及时确认</span>
              </div>
              <el-table :data="priceList" border size="mini" style="width: 100%;" v-loading="priceLoading">
                <el-table-column prop="createTime" label="时间" min-width="160"></el-table-column>
                <el-table-column prop="spuCode" label="SPU" min-width="140"></el-table-column>
                <el-table-column prop="skcCode" label="SKC" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="skuCode" label="SKU" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column prop="typeDescription" label="价格类型" min-width="120">
                  <template slot-scope="scope">
                    <div style="display: flex; align-items: center; gap: 6px">
                      <i
                          :class="getPriceTypeIcon(scope.row.typeDescription)"
                          :style="{ color: getPriceTypeColor(scope.row.typeDescription), fontSize: '16px' }"
                      ></i>
                      <span>{{ scope.row.typeDescription }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="oldValue" label="原值" min-width="80" :formatter="formatNumber"/>
                <el-table-column prop="newValue" label="现值" min-width="150">
                  <template slot-scope="scope">
                    <div style="display: flex; align-items: center; gap: 6px">
                      <span>{{ Number(scope.row.newValue).toFixed(2) }}</span>
                      <span
                          v-if="Number(scope.row.newValue) > Number(scope.row.oldValue)"
                          style="color: #f56c6c; display: flex; align-items: center; gap: 2px"
                      >
                        <i class="el-icon-top"></i>
                        <span style="font-size: 12px;">+{{ calculatePercent(scope.row.newValue, scope.row.oldValue) }}%</span>
                      </span>
                      <span
                          v-else-if="Number(scope.row.newValue) < Number(scope.row.oldValue)"
                          style="color: #67c23a; display: flex; align-items: center; gap: 2px"
                      >
                        <i class="el-icon-bottom"></i>
                        <span style="font-size: 12px;">{{ calculatePercent(scope.row.newValue, scope.row.oldValue) }}%</span>
                      </span>
                      <span v-else style="color: #909399;">
                        <i class="el-icon-remove"></i>
                        <span style="font-size: 12px;">持平</span>
                      </span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div style="display: flex; justify-content: flex-end; padding-top: 12px;">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="priceTotal"
                    :page-size="pricePageSize"
                    :current-page.sync="pricePageNum"
                    @current-change="fetchPriceList"
                />
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="文本通知" name="text">
          <div v-loading="textLoading" style="min-height: 300px;">
            <!-- 空状态 -->
            <div v-if="textList.length === 0 && !textLoading" style="text-align: center; padding: 60px 0; color: #909399;">
              <i class="el-icon-document" style="font-size: 48px; color: #d1d5db;"></i>
              <p style="margin-top: 12px; font-size: 14px;">暂无文本通知</p>
            </div>
            <!-- 文本列表 -->
            <div v-else>
              <div
                  v-for="item in textList"
                  :key="item.id"
                  style="border: 1px solid #ebeef5; border-radius: 8px; padding: 16px 20px; margin-bottom: 12px; transition: all 0.2s; background: #fff;"
                  @mouseenter="e => e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)'"
                  @mouseleave="e => e.currentTarget.style.boxShadow = 'none'"
              >
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; padding-bottom: 8px; border-bottom: 1px solid #f0f0f0;">
                  <span style="font-size: 13px; color: #909399;">{{ item.createTime }}</span>
                </div>
                <div style="display: flex; flex-direction: column; gap: 8px;">
                  <!-- 文本内容 -->
                  <div
                      class="text-content"
                      :class="{ expanded: item.expanded }"
                      v-html="formatText(item.noticeText)"
                  ></div>
                  <!-- 展开/收起 -->
                  <div
                      v-if="item.noticeText && item.noticeText.length > 100"
                      style="color: #409eff; font-size: 13px; cursor: pointer; user-select: none; margin-top: 4px;"
                      @click="toggleExpand(item)"
                  >
                    {{ item.expanded ? '收起' : '展开全部' }}
                    <i :class="item.expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                  </div>
                  <!-- 附件 -->
                  <div v-if="item.fileUrl" style="display: flex; align-items: center; gap: 8px; margin-top: 8px; padding: 8px 12px; background: #f5f7fa; border-radius: 4px;">
                    <i class="el-icon-paperclip" style="color: #409eff; font-size: 16px;"></i>
                    <a
                        :href="item.fileUrl"
                        :download="item.fileName || '附件'"
                        target="_blank"
                        style="color: #409eff; text-decoration: none; font-size: 13px;"
                        @mouseenter="e => e.currentTarget.style.textDecoration = 'underline'"
                        @mouseleave="e => e.currentTarget.style.textDecoration = 'none'"
                    >
                      {{ item.fileName || '点击下载附件' }}
                    </a>
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <div style="display: flex; justify-content: flex-end; padding-top: 12px;">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="textTotal"
                    :page-size="textPageSize"
                    :current-page.sync="textPageNum"
                    @current-change="fetchTextList"
                />
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSysNoticeList } from '@/api'

export default {
  name: 'NoticeCenter',
  data() {
    return {
      dialogVisible: false,
      activeTab: 'price',
      textLoaded: false,  // 文本是否已加载

      // 价格通知
      priceList: [],
      priceTotal: 0,
      pricePageNum: 1,
      pricePageSize: 10,
      priceLoading: false,

      // 文本通知
      textList: [],
      textTotal: 0,
      textPageNum: 1,
      textPageSize: 10,
      textLoading: false
    }
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true
      this.activeTab = 'price'
      this.pricePageNum = 1
      this.textPageNum = 1
      this.textLoaded = false
      this.fetchPriceList()
      // 不加载文本，等点击tab再加载
    },

    // 关闭弹窗
    handleClosed() {
      this.textList.forEach(item => {
        item.expanded = false
      })
    },

    // Tab 切换
    handleTabChange(tab) {
      if (tab.name === 'text' && !this.textLoaded) {
        this.fetchTextList()
      }
    },

    // 获取价格通知列表
    async fetchPriceList() {
      this.priceLoading = true
      try {
        const res = await getSysNoticeList({
          pageNum: this.pricePageNum,
          pageSize: this.pricePageSize,
          type: 1
        })
        this.priceList = res.data?.records || []
        this.priceTotal = res.data?.total || 0
      } catch (e) {
        console.error('获取价格通知失败', e)
        this.priceList = []
        this.priceTotal = 0
      } finally {
        this.priceLoading = false
      }
    },
    toggleExpand(item) {
      item.expanded = !item.expanded
      // 强制更新视图
      this.$forceUpdate()
    },
    // 获取文本通知列表
    async fetchTextList() {
      this.textLoading = true
      try {
        const res = await getSysNoticeList({
          pageNum: this.textPageNum,
          pageSize: this.textPageSize,
          type: 2
        })
        this.textList = (res.data?.records || []).map(item => ({
          ...item,
          expanded: false
        }))
        this.textTotal = res.data?.total || 0
        this.textLoaded = true
      } catch (e) {
        console.error('获取文本通知失败', e)
        this.textList = []
        this.textTotal = 0
      } finally {
        this.textLoading = false
      }
    },

    // 格式化数字
    formatNumber(row, column, cellValue) {
      if (cellValue === null || cellValue === undefined || cellValue === '') return '-'
      const num = Number(cellValue)
      if (isNaN(num)) return cellValue
      return num.toFixed(2)
    },

    // 计算百分比
    calculatePercent(newValue, oldValue) {
      const newNum = Number(newValue)
      const oldNum = Number(oldValue)
      if (isNaN(newNum) || isNaN(oldNum) || oldNum === 0) {
        return '0'
      }
      return ((newNum - oldNum) / oldNum * 100).toFixed(2)
    },

    // 获取价格类型图标
    getPriceTypeIcon(typeDescription) {
      if (typeDescription === '国外拿货' || typeDescription === '国外拿货价') {
        return 'el-icon-s-promotion'
      } else if (typeDescription === '国内拿货' || typeDescription === '国内拿货价') {
        return 'el-icon-s-shop'
      }
      return 'el-icon-price-tag'
    },

    // 获取价格类型颜色
    getPriceTypeColor(typeDescription) {
      if (typeDescription === '国外拿货' || typeDescription === '国外拿货价') {
        return '#f56c6c'
      } else if (typeDescription === '国内拿货' || typeDescription === '国内拿货价') {
        return '#67c23a'
      }
      return '#909399'
    },

    // 格式化文本（支持换行）
    formatText(text) {
      if (!text) return ''
      return text.replace(/\n/g, '<br>')
    }
  }
}
</script>

<style scoped>

.text-content.expanded {
  max-height: none;
}
.text-content {
  font-size: 14px;
  color: #303133;
  line-height: 1;
  word-break: break-word;
  white-space: pre-wrap;
  max-height: 100px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.text-content.expanded {
  max-height: none !important;
  overflow: visible !important;
}
</style>